export const calculateDaysLeft = (data: any) => {
  const startsAt = data?.startsAt ? new Date(data.startsAt) : null;
  if (!startsAt) {
    return null;
  }
  const currentDate = new Date();
  const daysLeft = Math.ceil((startsAt.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24));

  return daysLeft;
};
